import React, { useState } from "react";
import { FileText, ChevronDown, ChevronUp } from "lucide-react";
import { useProductInfo } from "../../hooks/useProductInfo";
import "./styles/DescriptionCard.css";

const CHAR_LIMIT = 300;

const DescriptionCard: React.FC = () => {
  const { description } = useProductInfo();
  const [expanded, setExpanded] = useState(false);

  if (!description?.trim()) return null;

  const needsToggle = description.length > CHAR_LIMIT;
  const display = needsToggle && !expanded ? description.slice(0, CHAR_LIMIT) + "…" : description;

  return (
    <div className="descv2 glass-card">
      <div className="descv2__header">
        <FileText size={18} strokeWidth={2.5} />
        <span className="descv2__label">Description</span>
      </div>
      <p className="descv2__text">{display}</p>
      {needsToggle && (
        <button className="descv2__toggle" onClick={() => setExpanded((e) => !e)}>
          {expanded ? <><ChevronUp size={16} /> Show Less</> : <><ChevronDown size={16} /> Read More</>}
        </button>
      )}
    </div>
  );
};

export default DescriptionCard;
